import * as React from 'react'
import Modal from './Modal'
import { createPortal } from 'react-dom'
import { UIContext } from '../../shared/context/UIContext'

const Container = () => {
  CreateModalWrapper()
  return <ContainerWapper />
}

const CreateModalWrapper = () => {
  if (!document.getElementById('modalContainer')) {
    const wrapper = document.createElement('div')
    wrapper.id = 'modalContainer'
    wrapper.style.position = 'relative'
    document.body.appendChild(wrapper)
  }
}

const ContainerWapper = () => {
  const { modalContent } = React.useContext(UIContext)
  const modalWrapper: HTMLElement | null = document.getElementById('modalContainer')
  return modalContent && modalWrapper ? createPortal(<Modal {...modalContent} />, modalWrapper) : null
}

export default Container
